<template>
  <div class="content">
    <div class="text">
      <p class="title" id="title">{{ title }}</p>
      <p
        class="desc"
        v-for="(item, index) in desc"
        :key="index"
      >
        {{ item.text }}
      </p>
      <!-- <div class="btn">
        <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
        <img src="@/assets/images/ios.png" class="btn ios" @click.stop="gpAction(true)" alt="">
      </div> -->
      <div class="btns">
        <div class="btn">
          <img src="@/assets/images/gp.png" @click.stop="gpAction(false)"/>
        </div>
      </div>
    </div>
    <!-- <img src="@/assets/images/screen.png" class="phone" /> -->
     <img src="@/assets/images/banner.png" class="banner" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
      screen: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      console.log(config);
      // this.screen = `${config.baseUrl}images/screen.png?v=${new Date().getTime()}`;
      this.screen = `${config.screen}`;
      const { title, desc } = config.page[0];
      this.title = title;
      this.desc = desc;
    },
    gpAction(isIos = false){
      // window.gtagEvent('10001')
      // alert('Coming soon')
      // if (isIos) {
      //   window.open('https://apps.apple.com/us/app/id6503810311');
      // } else {
      //   window.open('https://play.google.com/store/apps/details?id=ai.character.talkie.waifu');
      // }
      window.open('https://play.google.com/store/apps/details?id=com.ai.video.maker.guru.app');
    }
  },
};
</script>

<style lang="less">
.content {
  padding: 6px 0 28px;
  flex: 1;
  // background-image: url( "~@/assets/images/bg.png" );
  // background-color: #2e2e2e;
  background-color: #000;
  background-size: cover;
  width: 100%;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  flex-direction: column;
  .phone {
    width: 233px;
    border-radius: 3px;
  }
  .text {
    // margin-right: 56px;
    // max-width: 540px;
    max-width: 800px;
    img{
      width: 140px;
      margin-top: 12px;
    }
  }
  .title {
    font-size: 30px;
    font-family: "Momo Trust Display", Poppins, PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 38px;
    margin-bottom: 20px;
  }
  .desc {
    font-size: 14px;
    font-family: Poppins, PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 2;
    margin-bottom: 18px;
  }
  .btns{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
  }
  .btn{
    cursor: pointer;
    border: 2px solid #0e0ebc;
    border-radius: 30px;
    img{
      width: 140px;
      margin-top: 6px;
    }
    &:hover{
      border-color: #0202ff;
    }
    // &.ios{
    //   height: 36px;
    //   width: auto;
    //   margin-left: 30px;
    // }
  }
}
.banner{
  max-width: 800px;
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
